import React from 'react';
import { Box, Paper } from '@mui/material';
import { useLocation, Outlet } from 'react-router-dom';

const ProductLayout: React.FC = () => {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', p: 2, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          borderRadius: 2,
          overflow: 'hidden'
        }}
      >
        <Outlet />
      </Paper>
    </Box>
  );
};

export default ProductLayout;